/**
 * @author Victor Andrade <victor.andrade@caixamagica.pt>,
 *
 * @see react-intl docs: https://github.com/formatjs/react-intl
 *
 * @version 20200915
 * @since 20200915 Initial release
 *
 */

import { defineMessages } from 'react-intl';

import { AVAILABLE_LOCALES } from 'constants/user';

import enGBLang from './entries/en-GB';
import ptPTLang from './entries/pt-PT';

const AppLocale = {
    [AVAILABLE_LOCALES.ptPT]: ptPTLang,
    [AVAILABLE_LOCALES.enGB]: enGBLang,
};

defineMessages(AppLocale[AVAILABLE_LOCALES.ptPT].data);
defineMessages(AppLocale[AVAILABLE_LOCALES.enGB].data);

export default AppLocale;
